<template>
  <div>
    <div v-if="primaryCta">
      <theme-btn
        v-if="$mq === 'mob' || $mq === 'ptab'"
        class="btn--shape--h48--not-phab min-w--217--not-phab min-w--168--phab"
        v-on:click="unauthorisedClick"
        target="_blank"
      >{{ text || "Download" }}</theme-btn>
      <theme-btn
        v-else
        v-on:click="unauthorisedClick"
        class="btn--shape--h48--not-phab w--100p"
      >{{ text || "Download" }}</theme-btn>
    </div>
    <div v-else>
      <mq-layout :mq="['mob', 'ptab']">
        <a
          class="fonticon fonticon--plus--circle fs--40"
          v-on:click="unauthorisedClick"
          target="_blank"
        ></a>
      </mq-layout>
      <mq-layout :mq="['ltab', 'desk']">
        <a
          class="link--action link--arrow"
          target="_blank"
          v-on:click="unauthorisedClick"
        >{{ text || "Download" }}</a>
      </mq-layout>
    </div>
  </div>
</template>

<script>
import { forEach, map, find, filter, cloneDeep, intersection, orderBy } from 'lodash';
import Btn from "../atoms/Btn";
import ThemeBtn from "../atoms/ThemeBtn";
import InfoTooltip from "../molecules/InfoTooltip";

export default {
  components: {
    Btn,
    InfoTooltip
  },
  data() {
    return {
      downloadGame: null,
      gamesList: []
    }
  },
  props: {
    text: String,
    asset: Number,
    primaryCta: Boolean
  },
  computed: {
    hasPermission: function() {
      var self = this;
      return self.$root.userHasPermission({
        igt: ["AM", "CM", "SA"],
        operator: ["customer", "performance"]
      });
    }
  },
  created() {
    var self = this;

    var games = self.$root.$data.gamesPromise.then(games => {
      self.gamesList = self.$root.$data.games;
      self.setDownloadGame(self.asset);
    });
  },
  methods: {
    setDownloadGame(gameId) {
      var self = this;

			var downloadGame = find(self.$root.$data.games, {
				id: gameId
      });
      
			if (downloadGame) {
				self.downloadGame = downloadGame;
			}
		},
    unauthorisedClick(evt) {
      var self = this;

      if (!self.hasPermission) {
        evt.preventDefault();
        evt.stopPropagation();
        self.$refs.downloadTooltip.isVisible = true;
        return;
      } else {
        self.trackEvent([
          "news-download-assets-clicked",
          self.downloadGame.gameName,
          self.$root.$data.user ? self.$root.$data.user.trackName : null,
          0,
          false
        ]);

      self.$emit('showGameInfo', self.downloadGame)
      //self.$refs.gameList.setActiveGame(self.downloadGame, 1000);
      // self.$root.$data.gameAsset = self.downloadGame;

      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/organisms/DownloadFileHeroButton.vue